//Production api link:
const rootURL = "https://ofishstagingapiv2.azurewebsites.net/api";
//Dev new URL
// const rootURL =
//   "https://calendarapis-h3cyddbkh0aba2at.canadacentral-01.azurewebsites.net/api";

export const endpoints = {
  calendar: {
    getUserEvent: `${rootURL}/Calendar/GetUserEvents?id=`,
    addUpdateEvent: `${rootURL}/Calendar/AddUpdateEvent`,
    deleteEvent: `${rootURL}/Calendar/delete/`,
    getUserTeamAvailability: `${rootURL}/Calendar/GetUserTeamsAvailability`,
  },
  email: {
    getEmail: `${rootURL}/Calendar/GetUserMails?id=`,
    sendEmail: `${rootURL}/Calendar/SendReplyEmail`,
  },
  baseUrl: rootURL,
};
